import { MutationTree } from 'vuex'
import { Events } from './types'

export const mutations: MutationTree<Events> = {
  setAgents(state, { agents }) {
    state.agents = agents
  },
  setFilterAgentsByString(state, { filterAgents }) {
    state.filterAgents = filterAgents
  },
  resetFilterAgentsState(state) {
    state.filterAgents = state.agents
  },
  setCurrentAgent(state, { currentAgent }) {
    state.currentAgent = currentAgent
  }
}
